<template>
    <div class="box">
      <Layout>
        <div class="contaner">
            <p><img class="bg" src="../assets/bg.png" alt="" /></p>
           <div class="bg-top">
               <Row>
                      <Col span="5">
                      <!-- 合作 -->
                     &nbsp;
                      </Col>
                      <Col span="2">&nbsp;
                      <!-- 帮助 -->
                      </Col>
                      <Col span="17"><div class="login-btn" @click="login">登录</div></Col>
             </Row>
             <div class="bg-center"> 
                 <h1>娃娃鱼项目外包服务平台</h1>
                 <p>标准化制作流程开拓者</p>
                 <Button type="success" @click="register">供应商入驻</Button>
             </div>
             <ul class="bg-bottom">
                 <li>
                     <p>*****</p>
                     <p>累计交易金额</p>
                 </li>
                  <li>
                     <p>***</p>
                     <p>项目数量</p>
                 </li>
                   <li>
                     <p>***</p>
                     <p>已入驻供应商</p>
                 </li>

             </ul>
           </div>
        </div>
        <Content>
            <h1>加入娃娃鱼,马上开启合作</h1>
            <img src="../assets/flow.png" alt="">
            <!-- 表格 -->
            <div class="table-content">
                <!-- <h2>最新发布</h2> -->
                <ul class="table-head" v-if="data1.length>0">
                    <li>项目名称</li>
                    <li style="color:#4B5F79;">项目预算</li>
                    <li>项目周期</li>
                    <li>已竞标</li>
                    <li> </li>
                </ul>
                 <ul class="table-head" v-for="(item,index) in data1" :key="index">
                    <li>{{item.name}}</li>
                    <li>{{item.money}}</li>
                    <li>{{item.cycle}}</li>
                    <li>{{item.num}}</li>
                    <li><Button size="small" type="error">竞标中</Button> </li>
                </ul>
            </div>
            <!-- 轮播 -->
            <!-- <carouselList :CarouselList="CarouselList" :CarouselRightList="CarouselRightList"></carouselList> -->
        </Content>
        <!-- 页脚 -->
        <footerItem></footerItem>
    </Layout>
<!-- 登录注册模块 -->
    <regModal :modal1="modal1" @click="subRegster" @clickReg="closeReg"></regModal>
    <loginModal :modal2="modal2" @clickLogin="subLogin" @closeClick="close" @click="showPsw"></loginModal>
    <findPswModal :modal3="modal3" @click="resetPassword" @closePsw="closePs"> </findPswModal>
    <agreeModal :modal4="modal4" :time="time" @click="contine"></agreeModal>
</div>
</template>
<script>
import regModal from '../components/reg-modal.vue'
import agreeModal from '../components/agree-modal.vue'
import loginModal from '../components/login-modal.vue'
import findPswModal from '../components/findPsw-modal.vue'
import carouselList from "../components/carouselList.vue"
import footerItem from "../components/footerItem.vue"
export default {
    components:{
        regModal,
        loginModal,
        carouselList,
        footerItem,
        findPswModal,
        agreeModal
    },
    data(){
        return{
            modal1:false,
            modal2:false,
            modal3:false,
            modal4:false,
                data1: [],
                CarouselList:[],
                CarouselRightList:[],
            time:5,
            timer:null
        }
    },
    mounted(){

    },
    methods:{
        showPsw(){
            this.modal2=false;
            this.modal3=true;
            console.log(this.modal3)
        },
        contine(flag){
             
            if(flag){
                 
                if(this.time==0){
                     this.modal4=false;
                    this.modal1=true;
                }
            }else{
                this.modal4=false;
            }
        },
        subRegster(){//注册提交
            this.modal1=false;
        },
        register(){//供应商入驻
        this.modal4=true;
        this.time=5;
        this.timer=setInterval(()=>{
          this.time--;
          if(this.time==0){
              clearInterval(this.timer)
          }
      },1000)
            // this.modal1=true;
        },
        closeReg(){
           this.modal1=false;
        },
        subLogin(){//登录提交
            this.modal2=false;
            this.$router.push({ path: "/index"});
        },
        close(){
           this.modal2=false;
        },
        resetPassword(){//找回密码
            this.modal3=false;
        },
        closePs(){
            this.modal3=false;
        },
        login(){//登录
            this.modal2=true;
        }
    }
}
</script>
<style scoped lang="less">
@baseColor:#4B5F79;
@baseWidth:1800px;
.ivu-layout-header{
    background-color: #fff;
}

  @media screen and (max-width: 1800px) {
            .box {
                width: 100%;
            }
        }
          @media screen and (min-width: 1800px) {
            .box {
               width: @baseWidth;
            }
        }
.box{
        margin:0 auto;
        @media screen and (max-width: 1800px) {
            .contaner {
                width: 100%;
            }
        }
         @media screen and (min-width: 1800px) {
            .contaner {
               width: @baseWidth;
            }
        }
        .contaner{
    position: relative;
    >p{
        width: 100%;
        overflow: hidden;
    }
    .bg-top{
       width: 100%;
       position: absolute;
       left: 0px;
       top:0px;
    .ivu-col{
       text-align: right;
       color: #fff;
       height: 110px;
       line-height: 110px;
       cursor: pointer;
       .login-btn{
          display: inline-block;
          width: 94px;
          height: 38px;
          line-height: 38px;
          border-radius: 10px;
          border:1px solid #fff;
          text-align: center;
         margin-right:80px;
      }
   }
   .bg-center{
       text-align: center;
       color: #fff;
       margin-top: 56px;
       h1{
           font-size: 40px;
       }
       p{
           margin-top: 28px;
           margin-bottom: 80px;
           font-size: 18px;
       }
       button{
           font-size: 18px;
           height: 48px;
           width: 196px;
       }
   }
   .bg-bottom{
       width: 1140px;
       margin:0 auto;
       margin-top:160px;
       background-color: #fff;
       display: flex;
       padding:25px 0px;
       box-shadow: 0px 3px 5px #D9DDE3;
       li{
           flex: 1;
           text-align: center;
           font-size: 18px;
           color: #8696A7;
       }
       li:nth-child(2){
           border-left:1px solid #D9DDE3;
           border-right:1px solid #D9DDE3;
       }
   }
    }
}
.ivu-layout-content{
    width: 100%;
    text-align: center;

    h1{
        text-align: center;
        margin-top: 100px;
        color: #4B6079;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 50px;
    }
    >img{
        margin-bottom:90px;
    }
    .table-content{
        background-color: #fff;
        padding:26px;
        h2{
            font-size: 28px;
            color:#4B6079;
            font-weight: normal;
            margin-bottom:30px;
        }
        .table-head{
            width: 1123px;
            margin:0 auto;
            display: flex;
            border-bottom:1px solid #ECECEC;
            height: 56px;
            line-height: 56px;
            li{
                width: 400px;
                color:@baseColor;
                font-size: 14px;
                text-align: center;
            }
             li:nth-child(2){
                color: #F67F58;
            }
            li:nth-child(2),li:nth-child(3){
                   width: 200px;
            }
            li:nth-child(4){
                   width: 160px;
            }
            li:nth-child(5){
                   width: 110px;
            }
        }
      
        .table-head:last-child{
            border-bottom: none;
        }

    }
 
}

}

  

</style>



// WEBPACK FOOTER //
// src/view/index.vue